<div
    [class]="{'is-focused': $any(password).isFocused, 'input--filled': !!formControl.value, 'has-error': submitted() && !!errors }"
    class="form-group label-static is-empty">
  <label for="password" class="control-label">
    <span>{{ 'generic.password' | translate }}</span>
    <span class="required">*</span>
  </label>
  <input class="form-control"
         [formControl]="formControl"
         required
         type="password"
         #password appFocusable (onFocusChange)="$any(password).isFocused = $event"
         id="password">
  <app-input-errors [class.show-as-hint]="!submitted()"
                    [errorsForField]="errors"
                    [translationKey]="'errors.members'"/>

</div>
<div
    [class]="{'is-focused': $any(confirmpassword).isFocused, 'input--filled': !!formControl.value, 'has-error': submitted() && !!errors }"
    class="form-group label-static is-empty">
  <label for="confirm_password" class="control-label">
    <span>{{ 'generic.confirm_password' | translate }}</span>
    <span class="required">*</span>
  </label>
  <input class="form-control"
         [formControl]="confirmPasswordFormControl"
         required
         type="password"
         #confirmpassword appFocusable (onFocusChange)="$any(confirmpassword).isFocused = $event"
         id="confirm_password">
</div>
